import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const PanelWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
  boxShadow: theme.shadows[1],
  padding: 16,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  transition: 'box-shadow 0.2s ease',

  '&:hover': {
    boxShadow: theme.shadows[2],
  },
}));

export const PanelHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 8,
  minHeight: 32,
});

export const PanelTitle = styled('span')(({ theme }) => ({
  fontSize: theme.typography.h3.fontSize,
  fontWeight: theme.typography.h3.fontWeight,
  color: theme.palette.text.primary,
  lineHeight: 1.4,
}));

export const PanelActions = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

export const MinMaxRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '4px 8px 0',
});

export const MinMaxLabel = styled(Box)(({ color }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  fontSize: 12,
  color: color || 'inherit',
  '& .MuiSvgIcon-root': {
    fontSize: 16,
  },
}));

/* ─── Data table ─── */
export const DataTableWrapper = styled(Box)({
  maxHeight: 280,
  overflowY: 'auto',
  marginTop: 4,
  '& table': {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 13,
  },
  '& th': {
    position: 'sticky',
    top: 0,
    backgroundColor: '#2d3748',
    color: '#fff',
    fontWeight: 600,
    padding: '8px 12px',
    textAlign: 'left',
    fontSize: 12,
    letterSpacing: 0.3,
  },
  '& td': {
    padding: '6px 12px',
    borderBottom: '1px solid rgba(0,0,0,0.06)',
    fontSize: 13,
  },
  '& tr:hover td': {
    backgroundColor: 'rgba(255,153,0,0.06)',
  },
});

/* ─── Fullscreen modal overlay ─── */
export const FullscreenOverlay = styled(Box)({
  position: 'fixed',
  inset: 0,
  zIndex: 1300,
  backgroundColor: 'rgba(0,0,0,0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backdropFilter: 'blur(4px)',
});

export const FullscreenPanel = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: 16,
  boxShadow: theme.shadows[6],
  width: '92vw',
  maxWidth: 1200,
  maxHeight: '90vh',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

export const FullscreenHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 20px 12px',
  borderBottom: '1px solid rgba(0,0,0,0.08)',
});

export const FullscreenBody = styled(Box)({
  flex: 1,
  overflow: 'auto',
  padding: 20,
});
